import PropTypes from 'prop-types';
import {lazy} from 'react';
import {connect} from 'react-redux';
import Language from '../../lang/language';
import {isCollapsibleExperiment} from '../../selectors/ExperimentSelectors';
import getRequiresSiteTandCConfirmationInfoMsg from '../../selectors/getRequiresSiteTandCConfirmationInfoMsgSelector';
import getRequiresSiteTandCConfirmation from '../../selectors/getRequiresSiteTandCConfirmationSelector';
import getRequiresTandCConfirmation from '../../selectors/getRequiresTandCConfirmationSelector';
import orderHasSubAndSaveItem from '../../selectors/getBasketContainsSubscriptionBySku';
import {getSelectedDeliveryCountry} from '../../selectors/selectors';
import GenericFallbackSuspense from '../ui/GenericFallback/GenericFallbackSuspense';

const AcknowledgedMessages = lazy(() => import('./AcknowledgedMessages'));

export function AcknowledgedMessageLazyLoader(props) {
  const hasMessage = props.requiresSubscriptionConfirmation
    || props.requiresDigitalConfirmation
    || props.requiresSubAndSaveConfirmation
    || props.requiresTandCConfirmation
    || props.requiresSiteTandCConfirmationInfoMsg
    || props.requiresSiteTandCConfirmation
    || props.consentMessages.length > 0;
  
  if (!hasMessage || props.hidden) return null;
  
  return (
    <GenericFallbackSuspense fallback={<span />}>
      <AcknowledgedMessages {...props} />
    </GenericFallbackSuspense>
  );
}

AcknowledgedMessageLazyLoader.defaultProps = {
  consentMessages: [],
};

AcknowledgedMessageLazyLoader.propTypes = {
  requiresSubscriptionConfirmation: PropTypes.bool.isRequired,
  requiresDigitalConfirmation: PropTypes.bool.isRequired,
  requiresSubAndSaveConfirmation: PropTypes.bool.isRequired,
  requiresTandCConfirmation: PropTypes.bool.isRequired,
  requiresSiteTandCConfirmationInfoMsg: PropTypes.bool.isRequired,
  requiresSiteTandCConfirmation: PropTypes.bool.isRequired,
  isStepActive: PropTypes.bool.isRequired,
  hidden: PropTypes.bool.isRequired,
  consentMessages: PropTypes.arrayOf(PropTypes.string),
};

const mapStateToProps = (state, ownProps) => {
  const {siteCode} = state.start.siteDataV2;
  const subAndSaveMessageKey = `messages.subAndSave.confirmation.${siteCode}`;
  const hasSubAndSaveMessage = Language.doesTranslationExist(subAndSaveMessageKey);
  
  return {
    requiresSubscriptionConfirmation: state.site.isShowAutoRenewSubscriptionWarning
      && getSelectedDeliveryCountry(state) === 'US',
    requiresDigitalConfirmation: state.start.basket.requiresDigitalConsent,
    requiresSubAndSaveConfirmation: hasSubAndSaveMessage && orderHasSubAndSaveItem(state),
    subAndSaveMessageKey,
    consentMessages: state.start.basket.consentMessages,
    requiresTandCConfirmation: getRequiresTandCConfirmation(state),
    requiresSiteTandCConfirmationInfoMsg: getRequiresSiteTandCConfirmationInfoMsg(state),
    requiresSiteTandCConfirmation: getRequiresSiteTandCConfirmation(state),
    hidden: !ownProps.isStepActive && isCollapsibleExperiment(state),
  };
};

export default connect(
  mapStateToProps,
)(AcknowledgedMessageLazyLoader);
